import React,{Component} from "react";
import TextField from "@material-ui/core/TextField";
import { Button, Grid, withStyles } from "@material-ui/core";
import { withTranslation } from 'react-i18next';
import styles from './styles';
import '../../i18n';
import AppRouter from '../../router/AppRouter/AppRouter';


class SignIn extends Component {
  constructor(props){
    super(props);
    this.handleSignIn = this.handleSignIn.bind(this)
  }

  handleSignIn(e) {
    const {onloggedIn} = this.props;
    e.preventDefault()
    let userDetails = e.target.testUsername.value
    onloggedIn(userDetails)
  }

  render() {
    const { classes, t } = this.props;
    return (
      <form onSubmit={this.handleSignIn}>
        <div className={classes.user_SignIn}>{AppRouter()}</div>
        <label >{t('screens.home.sub-title')}</label>
        <Grid container  >
          <Grid item xs={12}>
            <TextField
              id="testUsername"
              type="username"
              autoComplete="current-password"
              margin="normal"
              variant="outlined"
              required
              label={t('screens.home.UserName')}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="testPassword"
            type="password"
            autoComplete="current-password"
            margin="normal"
            variant="outlined"
            required
            label={t('screens.home.Password')}
          />
        </Grid>
        <Grid >
          <Button
            variant="contained"
            color="primary"
            className={`${classes.Sign_In_button} submit-button`}
            type="submit"
          >
            Sign In
          </Button>
        </Grid>
      </form>

    );
  }
}

export default withStyles(styles)(withTranslation()(SignIn));

